// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuex from 'vuex'

Vue.config.productionTip = false
Vue.use(Vuex)

import firebase from 'firebase/app';
import 'firebase/app';
import 'firebase/database';
import 'firebase/firestore';

const firebase_config = {
  apiKey: "AIzaSyDAY73frdnQnqbmJXNtwGwi3h5RFlRJDi8",
  authDomain: "itss-88a6d.firebaseapp.com",
  databaseURL: "https://itss-88a6d.firebaseio.com",
  projectId: "itss-88a6d",
  storageBucket: "itss-88a6d.appspot.com",
  messagingSenderId: "806749284973"
};
const app = firebase.initializeApp(firebase_config);
const store = new Vuex.Store({
  state: {
    firebase: app
  }
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  store
})



// WEBPACK FOOTER //
// ./src/main.js